module.exports = __webpack_public_path__ + "static/img/icon09.41c40e72.svg";